import Swiper from 'swiper/bundle';
import { BREAK_POINTS, MEDIA_QUERIES } from '@/js/constants';

const REQUIRED_SLIDER_COUNT = 2;

class TextCardsCarousel {
  constructor(el, { isSlider }) {
    this.el = el;
    this.isSlider = isSlider;
    this.slideEls = null;
    this.controlsEl = null;
    this.slideLength = 0;
    this.swiper = null;

    if (this.el) {
      this.initialize();
    }
  }

  initialize() {
    this.slideEls = this.el.querySelectorAll('.swiper-slide');
    this.controlsEl = this.el.querySelector('.js-carousel-controls');
    this.slideLength = this.slideEls.length;
    this.mql = window.matchMedia(MEDIA_QUERIES.MOBILE);
    this.isMobile = this.mql.matches;

    // スライダーを設定しない条件
    if (!this.isSlider || this.slideLength < REQUIRED_SLIDER_COUNT) {
      this.el.querySelector('.swiper-wrapper').dataset.slider = false;
      this.el.classList.add('not-swiper');
      if (this.controlsEl) {
        this.controlsEl.style.display = 'none';
      }
      return;
    }

    if (this.slideLength < REQUIRED_SLIDER_COUNT) {
      this.el.querySelector('.swiper-wrapper').dataset.slider = false;
      this.controlsEl.style.display = 'none';
      return;
    }

    if (this.isMobile || this.isSlider) {
      this.swiper = this.setupSlider();
    }

    this.mql.addEventListener('change', this.onChangeMql.bind(this));
  }

  setupSlider() {
    return new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 21,
      speed: 400,
      autoHeight: true,
      loop: true,
      navigation: {
        prevEl: this.controlsEl.querySelector('.swiper-button-prev'),
        nextEl: this.controlsEl.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
      },
      breakpoints: {
        // when window width is >= BREAK_POINT
        [BREAK_POINTS.DESKTOP]: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }

  destroySlider() {
    this.swiper.destroy();
    this.swiper = null;
    this.el.querySelector('.swiper-wrapper').dataset.slider = false;
  }

  onChangeMql(e) {
    this.isMobile = e.matches;

    if (!this.isMobile && !this.isSlider) {
      this.destroySlider();
    } else if (!this.swiper) {
      this.swiper = this.setupSlider();
    }
  }
}

export default class TextCards {
  constructor(selector) {
    this.els = document.querySelectorAll(selector);

    if (this.els) {
      this.initialize();
    }
  }

  initialize() {
    this.els.forEach((el) => {
      const carouselEl = el.querySelector('.js-text-cards-carousel');
      const isSlider = !!el.dataset.slider;
      this.carousel = new TextCardsCarousel(carouselEl, { isSlider });
    });
  }
}
